import { ItemModel } from '@leverege/ui-attributes'
import I18N from '@leverege/i18n'
import React from 'react'

import RoomOccupancy from './RoomOccupancy'

const id = 'ps.dataViewers.RoomOccupancySupportDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.RoomOccupancySupport',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : 'none',
  matches : { type : 'ItemInfoDataViewer', objectType : 'room' },
  createSettings : () => {
    let mdl = ItemModel.create()
    mdl = ItemModel.addType( mdl, 'room' )

    return mdl
  },
  render : ( props ) => {
    return React.createElement( RoomOccupancy, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
